import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../assets/logos/logo.png";
import LanguageSwitcher from "./LanguageSwitcher";
import "./AuthPageLayout.css";

/** Figma CheckCircleIcon — 56×56 filled #00A379 with white check */
export function AuthSuccessIcon({ className = "" }) {
  return (
    <svg
      className={`auth-status-icon auth-status-icon--success ${className}`.trim()}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="28" cy="28" r="28" fill="currentColor" />
      <path
        d="M17.5 28.5L24.5 35.5L38.5 21.5"
        stroke="#FFFFFF"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Shared chrome for public auth screens (Register, Account Created, Verify Email).
 * Matches OneHub Figma auth layout: logo + language in page header, centered card.
 */
function AuthPageLayout({ children, cardClassName = "" }) {
  const { i18n } = useTranslation("translation");

  return (
    <div
      className="auth-page-root"
      dir={i18n.dir()}
      lang={i18n.language}
    >
      <header className="auth-page-header">
        <Link to="/" className="auth-page-header__logo" aria-label="Loops">
          <img src={logo} alt="Loops" />
        </Link>
        <div className="auth-page-header__lang">
          <LanguageSwitcher />
        </div>
      </header>

      <main className="auth-page-main">
        <div className={`auth-page-card ${cardClassName}`.trim()}>
          {children}
        </div>
      </main>
    </div>
  );
}

export default AuthPageLayout;
